<template>
  <router-link
    v-bind:to="{
      name: 'ProductType',
      params: {
        name: name,
        type: 'feature',
      },
    }"
    class="product-item-appeal"
  >
    <div v-if="title" class="title">{{ title }}</div>
    <div v-else class="title-border" />
    <div class="detail-link-button">{{ productName }}の詳細はこちら ▶</div>
    <div class="appeal">{{ appeal }}</div>
    <div class="product-detail">
      <img
        class="product-logo-image"
        v-lazy="'/static/products/' + name + '/logo.png'"
        :alt="productName"
      />
      <p class="product-name">{{ productName }}</p>
      <span class="detail">{{ detail }}</span>
    </div>
    <img
      class="product-looks-image"
      v-lazy="'/static/products/' + name + '/choice.png'"
      :alt="productName"
    />
  </router-link>
</template>

<script>
export default {
  props: ['name', 'productName', 'title', 'appeal', 'detail'],
}
</script>

<style scoped>
.product-item-appeal {
  font-size: 14px;

  position: relative;

  display: block;

  min-height: 300px;

  text-decoration: none;

  color: #4d4d4d;
}

.title {
  font-weight: bold;

  margin: 15px 0;
  padding: 5px 20px;

  text-align: center;

  color: white;
  border-radius: 20px;
}

.for-outgoing .title {
  background-color: rgb(45, 183, 68);
}

.for-incoming .title {
  background-color: rgb(16, 106, 203);
}

.title-border {
  height: 12px;
  margin: 15px 0 15px;
  padding: 5px 20px 0;
}

.for-outgoing .title-border {
  border-bottom: 1px solid rgb(45, 183, 68);
}

.for-incoming .title-border {
  border-bottom: 1px solid rgb(16, 106, 203);
}

.detail-link-button {
  font-size: 11px;
  font-weight: bold;

  display: inline-block;

  margin: 0 0 16px;
  padding: 4px 14px;

  border-radius: 20px;
  border-width: 2px;
  border-style: solid;
}

.for-outgoing .detail-link-button {
  color: rgb(45, 183, 68);
  border-color: rgb(45, 183, 68);
}

.for-incoming .detail-link-button {
  color: rgb(16, 106, 203);
  border-color: rgb(16, 106, 203);
}

.detail-link-button:hover {
  opacity: 0.6;
  transition: 0.3s;
}

.appeal {
  line-height: 16px;

  margin: 0 0 20px;

  white-space: pre-line;
}

.product-detail {
  position: relative;

  display: inline-block;

  white-space: pre-line;
}

.product-logo-image {
  width: 110px;
  height: auto;
}

.product-name {
  font-weight: bold;

  margin: 10px 0;
}

.product-looks-image {
  position: absolute;
  right: 20px;

  width: 50%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ProductItemAppeal.vue